module.exports = __webpack_public_path__ + "img/staff_icon.5e3027c6.png";